(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-pro"] && !Shopify.designMode) return;
  try {
    
  class TestimonialSlider {
    constructor(container) {
      this.container = container;
      this.slider = container.querySelector('[data-testimonial-slider]');
      this.slides = Array.from(container.querySelectorAll('[data-testimonial-slide]'));
      this.prevBtn = container.querySelector('[data-slider-prev]');
      this.nextBtn = container.querySelector('[data-slider-next]');
      this.dotsContainer = container.querySelector('[data-slider-dots]');
      this.currentIndex = 0;
      this.autoplayInterval = null;
      this.autoplayDelay = 5000;

      if (this.slides.length <= 1) return;

      this.init();
    }

    init() {
      this.createDots();
      this.showSlide(0);
      this.attachEvents();
      this.startAutoplay();
    }

    createDots() {
      if (!this.dotsContainer) return;

      this.slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.classList.add('hero-tms__slider-dot');
        dot.setAttribute('aria-label', `Go to testimonial ${index + 1}`);
        dot.addEventListener('click', () => this.goToSlide(index));
        this.dotsContainer.appendChild(dot);
      });

      this.dots = Array.from(this.dotsContainer.querySelectorAll('.hero-tms__slider-dot'));
    }

    showSlide(index) {
      this.slides.forEach((slide, i) => {
        slide.classList.remove('is-active', 'is-prev');
        if (i === index) {
          slide.classList.add('is-active');
        } else if (i < index) {
          slide.classList.add('is-prev');
        }
      });

      if (this.dots) {
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
        });
      }

      this.currentIndex = index;
      this.updateButtons();
    }

    updateButtons() {
      if (this.prevBtn) {
        this.prevBtn.disabled = false;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = false;
      }
    }

    goToSlide(index) {
      if (index < 0 || index >= this.slides.length) return;
      this.showSlide(index);
      this.resetAutoplay();
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    prevSlide() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }

    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        this.nextSlide();
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }

    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    attachEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prevSlide());
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.nextSlide());
      }

      // Pausar autoplay al hacer hover
      this.slider.addEventListener('mouseenter', () => this.stopAutoplay());
      this.slider.addEventListener('mouseleave', () => this.startAutoplay());

      // Soporte para touch/swipe
      let touchStartX = 0;
      let touchEndX = 0;

      this.slider.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
        this.stopAutoplay();
      });

      this.slider.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
        this.startAutoplay();
      });

      const handleSwipe = () => {
        const swipeThreshold = 50;
        if (touchStartX - touchEndX > swipeThreshold) {
          this.nextSlide();
        } else if (touchEndX - touchStartX > swipeThreshold) {
          this.prevSlide();
        }
      };

      this.handleSwipe = handleSwipe;
    }
  }

  // Inicializar slider cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }

  function initSliders() {
    const sliderContainers = document.querySelectorAll('.hero-tms__testimonial-wrapper');
    sliderContainers.forEach(container => new TestimonialSlider(container));
  }

  // Re-inicializar en Shopify theme editor
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(initSliders, 100);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
